import { svg } from "lit";
const icon = svg `<path d="M22.1069 19.9831L14.1582 12.0236L15.6496 10.5322L25.0897 19.9831L15.6496 29.4232L14.1582 27.9318L22.1069 19.9831Z" fill="currentColor"/>`;
export default icon;
